<template>
    <!--todo 分店、品牌、攤販、主辦單位資訊/活動頁都有第三方連結-->
    <div :class="(isFlat || isBrand) ? 'icons' : 'Links text-center mt-3'" v-if="websitesStatus">
        <div class="img" :class="'i'+(item.type-1)" v-for="(item,index) in websites" :key="index" @click="$public.openUrl(item.url)">
            <img :src="socialIcon[item.type-1]" />
        </div>
    </div>
</template>

<script>
import { remarkIconPath, remarkIconFlatPath, remarkIconFlatBrownPath } from "../../../store/constDefine";
    export default {
        name: "Links",
        props: {
            /*linkFb: { default: '' },
            linkIg: { default: '' },
            linkLine: { default: '' },
            linkYoutube: { default: '' },
            linkWebsite: { default: '' },
            linkTwitter: { default: '' },*/
            isFlat: Boolean,//扁平式設計
            isBrand: Boolean,//品牌金色icon
            socialWebsites: { default: '' },// { type:Array, default: Array.of({}) },
            socialWebsitesStatus: { default: false },
            iconType: { default: '' },
        },
        data() {
            return {
                socialIcon: this.iconType==="isFlat" ? remarkIconFlatPath:this.iconType==="isBrand" ? remarkIconFlatBrownPath:remarkIconPath,
                websites: this.socialWebsites===''?[]:this.socialWebsites==='[]'?[]:JSON.parse(this.socialWebsites),
                websitesStatus: this.socialWebsites===''?false:this.socialWebsites==='[]'?false:this.socialWebsitesStatus,
            }
        },
        watch: {
            //注意，當要監聽不是數值型的物件，而是參考或陣列的話，會監聽失敗
            // 因爲 watch並無法知道物件內某個元素的變化，也無法知道陣列內某個元素的變化

            //監聽，因爲包成元件的物件只能用 props來傳遞參數，在元件內部監聽參數是否有變化來抓資料
            // linkFb: function() {
            //     console.log(`linkFb : ${this.linkFb}`);
            // }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            /** icon 點擊事件 */
            onClick(link){
                //把 url傳到父元件
                this.$emit('onClick', link);
            },
        }
    }
</script>

